export default [
    {
        path: 'exame-producao',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-exame-producao' */
            '@/views/exame-laboratorial/exame-producao/Index'
        ),
        redirect: 'exame-producao/index',
        children: [
            {
                name: 'exame-laboratorial-exame-producao-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-exame-producao' */
                    '@/views/exame-laboratorial/exame-producao/List.vue'
                ),
            },
        ],
    }
]